<template>
  <DsTabs
    :screen="screen"
    :label="tabsLabel"
    type="buttons"
    full-screen-content
    contained
    use-grid
    :contained-content="!isScreenLarge"
  >
    <DsTabItem
      v-for="(tab, tabIndex) in items"
      :key="`gallery-tab-${tabIndex}`"
      :title="tab.title"
    >
      <DsImageGallery
        :key="`gallery-${tabIndex}`"
        :items="tab.items.length"
        :screen="screen"
        :width="itemsWidth"
        type="primary"
        class="ds-margin-top-24 ds-lg-margin-top-0"
      >
        <template #default="{ index }">
          <slot name="item" :item="tab.items[index - 1]" />
        </template>
      </DsImageGallery>
    </DsTabItem>
  </DsTabs>
</template>

<script setup>
import { DsTabs, DsTabItem, DsImageGallery } from 'awds'
const { screen, isScreenLarge } = useScreen()

const props = defineProps({
  tabsLabel: {
    type: String,
    required: true
  },
  items: {
    type: Array,
    required: true,
    validator: arr => arr.every(item => ['title', 'items'].every(key => key in item))
  },
  itemsWidth: {
    type: Object,
    default: () => ({ small: 264, large: 264 })
  }
})
</script>
